import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    backgroundColor: `${theme.palette.primary.light} !important`,
    height: '479px',
    boxShadow:
      '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
    borderRadius: '15px !important',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifySelf: 'center',
  },
  img: {
    objectPosition: 'center center',
    objectFit: 'contain',
    height: '159px',
  },
  column: {
    height: '18%',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0px 16px',
  },
  name: {
    fontFamily: 'Roboto !important',
    fontWeight: '500 !important',
    fontSize: '22px !important',
    color: 'rgba(0, 0, 0, 0.87) !important',
    letterSpacing: '0.15px !important',
    lineHeight: '160% !important',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textAlign: 'left',
  },
  columnButton: {
    height: '10%',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0px 16px',
    justifyContent: 'flex-start',
  },
  description: {
    fontFamily: 'Roboto !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    color: 'rgba(0, 0, 0, 0.75) !important',
    letterSpacing: '0.15px !important',
    lineHeight: '143% !important',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textAlign: 'justify',
    padding: '0px 16px !important',
  },
  columnPaymentType: {
    height: '5%',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0px 16px',
  },
  columnPrice: {
    height: '10%',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  columnDetail: {
    height: '8%',
    display: 'flex',
    width: '100%',
    padding: '0px 16px',
    textAlign: 'end',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));
